import { IAffiliate } from '@adminPortal/_common/_interfaces/IAffiliate';
import { IGetAffiliateListRequestData } from '@adminPortal/_common/_interfaces/IGetAffiliateListRequestData';
import { createActionGroup, emptyProps, props } from '@ngrx/store';
import { ITransaction } from '@adminPortal/_common/_interfaces/ITransaction';

export const AffiliateActions = createActionGroup({
  source: 'Affiliate',
  events: {
    'Load Affiliate List': props<{ requestData: IGetAffiliateListRequestData }>(),
    'Load Affiliate List Success': props<{ affiliateList: IAffiliate[] }>(),
    'Load Affiliate List Failure': props<{ error: any }>(),

    'Create New Affiliate': props<{ email: string; affiliateType: string }>(),
    'Create New Affiliate Success': emptyProps(),
    'Create New Affiliate Failure': props<{ error: any }>(),

    'Delete Affiliate': props<{ affiliate: IAffiliate }>(),
    'Delete Affiliate Success': emptyProps(),
    'Delete Affiliate Failure': props<{ error: any }>(),

    'Save Affiliate': props<{ affiliate: IAffiliate }>(),
    'Save Affiliate Success': props<{ affiliate: IAffiliate }>(),
    'Save Affiliate Failure': props<{ error: any }>(),

    'Affiliate Transfer Balance': props<{ amount: number, id: string }>(),
    'Affiliate Transfer Balance Success': props<{ affiliate: IAffiliate }>(),
    'Affiliate Transfer Balance Failure': props<{ error: any }>(),

    'Load Transactions': props<{ affiliateId: string }>(),
    'Load Transactions Success': props<{ transactions: ITransaction[] }>(),
    'Load Transactions Failure': props<{ error: any }>(),

    'Load My Transactions': emptyProps(),
    'Load My Transactions Success': props<{ transactions: ITransaction[] }>(),
    'Load My Transactions Failure': props<{ error: any }>(),
  },
});
